import protoRoot from "../proto-root";

const name = "getDetectionZonesPreviewRpcResponse";

function create(result: "SUCCESS" | "FAILURE", preview?: DetectionZonesPreview) {
  const GetDetectionZonesPreviewRPCResponse = protoRoot.lookupType("comm.GetDetectionZonesPreviewRPCResponse");
  const CameraInfo = protoRoot.lookupType("comm.CameraInfo");

  const Result = protoRoot.lookupEnum("Result");
  const CameraFacing = CameraInfo.lookupEnum("CameraFacing");
  const ImageRotation = protoRoot.lookupEnum("ImageRotation");

  const response = GetDetectionZonesPreviewRPCResponse.create({
    result: Result.values[result],
    preview: {
      ...preview,
      rotation: ImageRotation.values.ROTATION_0,
      cameraFacing: CameraFacing.values.EXTERNAL
    }
  });

  return { payload: response, name };
}

const getDetectionZonesPreviewRpcResponse = { create, name };

export default getDetectionZonesPreviewRpcResponse;
